/* eslint-disable @typescript-eslint/no-explicit-any */
// rootReducer.js
import { combineReducers } from 'redux';
import { appReducer, AppState } from './reducers/app';
import { queuesReducer, QueuesState } from './features/queues';
// import commentsReducer from './reducers/comments';
import { settingsReducer, SettingsState } from './features/settings';

export interface RootState {
  app: AppState;
  queues: QueuesState;
  settings: SettingsState;
}

export const rootReducer = combineReducers<RootState>({
  app: appReducer,
  // comments: commentsReducer,
  queues: queuesReducer,
  settings: settingsReducer
});
